var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9356 3.73289C10.9356 5.41644 9.55824 6.78122 7.85917 6.78122C6.16009 6.78122 4.78271 5.41644 4.78271 3.73289C4.78271 2.04935 6.16009 0.68457 7.85917 0.68457C9.55824 0.68457 10.9356 2.04935 10.9356 3.73289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.552734 13.8631C0.552734 10.6256 3.20153 8.00098 6.46899 8.00098H9.24963C12.5171 8.00098 15.1659 10.6256 15.1659 13.8631C15.1659 14.8344 14.3712 15.6218 13.391 15.6218H2.32761C1.34737 15.6218 0.552734 14.8344 0.552734 13.8631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhiteIcon);
export default __webpack_public_path__ + "static/media/user-white-icon.b41fcec131fd7593cc327c607dae437f.svg";
export { ForwardRef as ReactComponent };